import { validators } from '../utils';
import { makeFormComponent, makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

const addHouseholdMemberFormSchema = validators.object({
  email: validators.email(),
  firstName: validators.requiredString('First name'),
  lastName: validators.requiredString('Last name'),
  phoneNumber: validators.e164PhoneNumber(),
});

export type AddHouseholdMemberFormSchema = InferFormType<typeof addHouseholdMemberFormSchema>;

export const addHouseholdMemberFormDefaultValues: AddHouseholdMemberFormSchema = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
};

export const useAddHouseholdMemberForm = makeFormHook(
  addHouseholdMemberFormSchema,
  addHouseholdMemberFormDefaultValues,
);

export const AddHouseholdMemberForm = makeFormComponent(
  addHouseholdMemberFormSchema,
  addHouseholdMemberFormDefaultValues,
);
